export interface Assignee {
    id: string;
    name: string;
    role: string;
    initials: string;
    isSelf?: boolean;
}

export const currentUser: Assignee = {
    id: "self",
    name: "You",
    role: "General Manager",
    initials: "ME",
    isSelf: true
};

export const teammates: Assignee[] = [
    {
        id: "maria_lopez",
        name: "Maria Lopez",
        role: "Regional Manager",
        initials: "ML"
    },
    {
        id: "devon_carter",
        name: "Devon Carter",
        role: "District Manager",
        initials: "DC"
    },
    {
        id: "aisha_khan",
        name: "Aisha Khan",
        role: "Marketing Lead",
        initials: "AK"
    },
    {
        id: "tom_becker",
        name: "Tom Becker",
        role: "Shift Supervisor",
        initials: "TB"
    },
    {
        id: "emma_reed",
        name: "Emma Reed",
        role: "Store Manager",
        initials: "ER"
    },
    {
        id: "priya_nair",
        name: "Priya Nair",
        role: "Operations Analyst",
        initials: "PN"
    }
];

export const assignableTeam: Assignee[] = [currentUser, ...teammates];

export function findAssigneeByName(name: string | undefined): Assignee | null {
    if (!name) return null;
    return assignableTeam.find((person) => person.name === name) ?? null;
}
